/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { TriageResult } from './TriageResult';
import {
    TriageResultFromJSON,
    TriageResultFromJSONTyped,
    TriageResultToJSON,
    TriageResultToJSONTyped,
} from './TriageResult';
import type { ImageSchema } from './ImageSchema';
import {
    ImageSchemaFromJSON,
    ImageSchemaFromJSONTyped,
    ImageSchemaToJSON,
    ImageSchemaToJSONTyped,
} from './ImageSchema';
import type { CaptureAnnotation } from './CaptureAnnotation';
import {
    CaptureAnnotationFromJSON,
    CaptureAnnotationFromJSONTyped,
    CaptureAnnotationToJSON,
    CaptureAnnotationToJSONTyped,
} from './CaptureAnnotation';
import type { CaptureSource } from './CaptureSource';
import {
    CaptureSourceFromJSON,
    CaptureSourceFromJSONTyped,
    CaptureSourceToJSON,
    CaptureSourceToJSONTyped,
} from './CaptureSource';
import type { CaptureSummary } from './CaptureSummary';
import {
    CaptureSummaryFromJSON,
    CaptureSummaryFromJSONTyped,
    CaptureSummaryToJSON,
    CaptureSummaryToJSONTyped,
} from './CaptureSummary';
import type { ServerLengthSchema } from './ServerLengthSchema';
import {
    ServerLengthSchemaFromJSON,
    ServerLengthSchemaFromJSONTyped,
    ServerLengthSchemaToJSON,
    ServerLengthSchemaToJSONTyped,
} from './ServerLengthSchema';
import type { SpeciesResultSchema } from './SpeciesResultSchema';
import {
    SpeciesResultSchemaFromJSON,
    SpeciesResultSchemaFromJSONTyped,
    SpeciesResultSchemaToJSON,
    SpeciesResultSchemaToJSONTyped,
} from './SpeciesResultSchema';
import type { CaptureLabelSchema } from './CaptureLabelSchema';
import {
    CaptureLabelSchemaFromJSON,
    CaptureLabelSchemaFromJSONTyped,
    CaptureLabelSchemaToJSON,
    CaptureLabelSchemaToJSONTyped,
} from './CaptureLabelSchema';
import type { PhoneGps } from './PhoneGps';
import {
    PhoneGpsFromJSON,
    PhoneGpsFromJSONTyped,
    PhoneGpsToJSON,
    PhoneGpsToJSONTyped,
} from './PhoneGps';
import type { ImuSample } from './ImuSample';
import {
    ImuSampleFromJSON,
    ImuSampleFromJSONTyped,
    ImuSampleToJSON,
    ImuSampleToJSONTyped,
} from './ImuSample';
import type { GpsValidFix } from './GpsValidFix';
import {
    GpsValidFixFromJSON,
    GpsValidFixFromJSONTyped,
    GpsValidFixToJSON,
    GpsValidFixToJSONTyped,
} from './GpsValidFix';
import type { MediaSchema } from './MediaSchema';
import {
    MediaSchemaFromJSON,
    MediaSchemaFromJSONTyped,
    MediaSchemaToJSON,
    MediaSchemaToJSONTyped,
} from './MediaSchema';
import type { ManualCaptureOrigin } from './ManualCaptureOrigin';
import {
    ManualCaptureOriginFromJSON,
    ManualCaptureOriginFromJSONTyped,
    ManualCaptureOriginToJSON,
    ManualCaptureOriginToJSONTyped,
} from './ManualCaptureOrigin';
import type { TriggerSource } from './TriggerSource';
import {
    TriggerSourceFromJSON,
    TriggerSourceFromJSONTyped,
    TriggerSourceToJSON,
    TriggerSourceToJSONTyped,
} from './TriggerSource';
import type { FrameMetadata } from './FrameMetadata';
import {
    FrameMetadataFromJSON,
    FrameMetadataFromJSONTyped,
    FrameMetadataToJSON,
    FrameMetadataToJSONTyped,
} from './FrameMetadata';
import type { WeightDebug } from './WeightDebug';
import {
    WeightDebugFromJSON,
    WeightDebugFromJSONTyped,
    WeightDebugToJSON,
    WeightDebugToJSONTyped,
} from './WeightDebug';

/**
 * 
 * @export
 * @interface CaptureDetail
 */
export interface CaptureDetail {
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    catchId: string | null;
    /**
     * 
     */
    runId: string | null;
    /**
     * 
     */
    deviceId: string | null;
    /**
     * 
     */
    hostname: string | null;
    /**
     * 
     */
    displayCode: string | null;
    /**
     * 
     */
    triggerSource: TriggerSource | null;
    /**
     * 
     */
    captureStartTimestamp: number | null;
    /**
     * 
     */
    captureEndTimestamp: number | null;
    /**
     * 
     */
    captureDurationSeconds: number | null;
    /**
     * 
     */
    lengthMillimeters: number | null;
    /**
     * 
     */
    weightGrams: number | null;
    /**
     * 
     */
    hasError: boolean;
    /**
     * 
     */
    thumbnailUrl: string | null;
    /**
     * 
     */
    triageResult: TriageResult;
    /**
     * 
     */
    annotation: CaptureAnnotation | null;
    /**
     * 
     */
    source: CaptureSource;
    /**
     * 
     */
    linkedCaptureId: string | null;
    /**
     * 
     */
    manualOrigin?: ManualCaptureOrigin | null;
    /**
     * 
     */
    phoneLoggedAt?: Date | null;
    /**
     * 
     */
    phoneGps?: PhoneGps | null;
    /**
     * 
     */
    speciesResult?: SpeciesResultSchema | null;
    /**
     * 
     */
    serverLengthMillimeters?: number | null;
    /**
     * 
     */
    labels?: Array<CaptureLabelSchema>;
    /**
     * 
     */
    runStartedTimestamp: number | null;
    /**
     * 
     */
    lengthMethod: string | null;
    /**
     * 
     */
    lengthConfidence: number | null;
    /**
     * 
     */
    gpsLastValidFix: GpsValidFix | null;
    /**
     * 
     */
    gpsLastValidFixTime: number | null;
    /**
     * 
     */
    imageError: string | null;
    /**
     * 
     */
    lengthError: string | null;
    /**
     * 
     */
    imu: ImuSample | null;
    /**
     * 
     */
    weightDebug: WeightDebug | null;
    /**
     * 
     */
    frames: Array<FrameMetadata> | null;
    /**
     * 
     */
    chosenFrameIndex: number | null;
    /**
     * 
     */
    images: Array<ImageSchema>;
    /**
     * 
     */
    media: Array<MediaSchema>;
    /**
     * 
     */
    linkedCapture: CaptureSummary | null;
    /**
     * 
     */
    serverLength?: ServerLengthSchema | null;
    /**
     * 
     */
    resultJsonPresignedUrl?: string | null;
    /**
     * 
     */
    appliedShiftSeconds?: number;
}



/**
 * Check if a given object implements the CaptureDetail interface.
 */
export function instanceOfCaptureDetail(value: object): value is CaptureDetail {
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if ((!('catchId' in (value as Record<string, any>)) && !('catch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['catchId'] === undefined && (value as Record<string, any>)['catch_id'] === undefined)) return false;
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if ((!('displayCode' in (value as Record<string, any>)) && !('display_code' in (value as Record<string, any>))) || ((value as Record<string, any>)['displayCode'] === undefined && (value as Record<string, any>)['display_code'] === undefined)) return false;
    if ((!('triggerSource' in (value as Record<string, any>)) && !('trigger_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['triggerSource'] === undefined && (value as Record<string, any>)['trigger_source'] === undefined)) return false;
    if ((!('captureStartTimestamp' in (value as Record<string, any>)) && !('capture_start_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureStartTimestamp'] === undefined && (value as Record<string, any>)['capture_start_timestamp'] === undefined)) return false;
    if ((!('captureEndTimestamp' in (value as Record<string, any>)) && !('capture_end_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureEndTimestamp'] === undefined && (value as Record<string, any>)['capture_end_timestamp'] === undefined)) return false;
    if ((!('captureDurationSeconds' in (value as Record<string, any>)) && !('capture_duration_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureDurationSeconds'] === undefined && (value as Record<string, any>)['capture_duration_seconds'] === undefined)) return false;
    if ((!('lengthMillimeters' in (value as Record<string, any>)) && !('length_millimeters' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMillimeters'] === undefined && (value as Record<string, any>)['length_millimeters'] === undefined)) return false;
    if ((!('weightGrams' in (value as Record<string, any>)) && !('weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightGrams'] === undefined && (value as Record<string, any>)['weight_grams'] === undefined)) return false;
    if ((!('hasError' in (value as Record<string, any>)) && !('has_error' in (value as Record<string, any>))) || ((value as Record<string, any>)['hasError'] === undefined && (value as Record<string, any>)['has_error'] === undefined)) return false;
    if ((!('thumbnailUrl' in (value as Record<string, any>)) && !('thumbnail_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['thumbnailUrl'] === undefined && (value as Record<string, any>)['thumbnail_url'] === undefined)) return false;
    if ((!('triageResult' in (value as Record<string, any>)) && !('triage_result' in (value as Record<string, any>))) || ((value as Record<string, any>)['triageResult'] === undefined && (value as Record<string, any>)['triage_result'] === undefined)) return false;
    if (!('annotation' in value) || value['annotation'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if ((!('linkedCaptureId' in (value as Record<string, any>)) && !('linked_capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkedCaptureId'] === undefined && (value as Record<string, any>)['linked_capture_id'] === undefined)) return false;
    if ((!('runStartedTimestamp' in (value as Record<string, any>)) && !('run_started_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['runStartedTimestamp'] === undefined && (value as Record<string, any>)['run_started_timestamp'] === undefined)) return false;
    if ((!('lengthMethod' in (value as Record<string, any>)) && !('length_method' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMethod'] === undefined && (value as Record<string, any>)['length_method'] === undefined)) return false;
    if ((!('lengthConfidence' in (value as Record<string, any>)) && !('length_confidence' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthConfidence'] === undefined && (value as Record<string, any>)['length_confidence'] === undefined)) return false;
    if ((!('gpsLastValidFix' in (value as Record<string, any>)) && !('gps_last_valid_fix' in (value as Record<string, any>))) || ((value as Record<string, any>)['gpsLastValidFix'] === undefined && (value as Record<string, any>)['gps_last_valid_fix'] === undefined)) return false;
    if ((!('gpsLastValidFixTime' in (value as Record<string, any>)) && !('gps_last_valid_fix_time' in (value as Record<string, any>))) || ((value as Record<string, any>)['gpsLastValidFixTime'] === undefined && (value as Record<string, any>)['gps_last_valid_fix_time'] === undefined)) return false;
    if ((!('imageError' in (value as Record<string, any>)) && !('image_error' in (value as Record<string, any>))) || ((value as Record<string, any>)['imageError'] === undefined && (value as Record<string, any>)['image_error'] === undefined)) return false;
    if ((!('lengthError' in (value as Record<string, any>)) && !('length_error' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthError'] === undefined && (value as Record<string, any>)['length_error'] === undefined)) return false;
    if (!('imu' in value) || value['imu'] === undefined) return false;
    if ((!('weightDebug' in (value as Record<string, any>)) && !('weight_debug' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightDebug'] === undefined && (value as Record<string, any>)['weight_debug'] === undefined)) return false;
    if (!('frames' in value) || value['frames'] === undefined) return false;
    if ((!('chosenFrameIndex' in (value as Record<string, any>)) && !('chosen_frame_index' in (value as Record<string, any>))) || ((value as Record<string, any>)['chosenFrameIndex'] === undefined && (value as Record<string, any>)['chosen_frame_index'] === undefined)) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('media' in value) || value['media'] === undefined) return false;
    if ((!('linkedCapture' in (value as Record<string, any>)) && !('linked_capture' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkedCapture'] === undefined && (value as Record<string, any>)['linked_capture'] === undefined)) return false;
    return true;
}

export function CaptureDetailFromJSON(json: any): CaptureDetail {
    return CaptureDetailFromJSONTyped(json, false);
}

export function CaptureDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'captureId': json['capture_id'],
        'catchId': json['catch_id'],
        'runId': json['run_id'],
        'deviceId': json['device_id'],
        'hostname': json['hostname'],
        'displayCode': json['display_code'],
        'triggerSource': TriggerSourceFromJSON(json['trigger_source']),
        'captureStartTimestamp': json['capture_start_timestamp'],
        'captureEndTimestamp': json['capture_end_timestamp'],
        'captureDurationSeconds': json['capture_duration_seconds'],
        'lengthMillimeters': json['length_millimeters'],
        'weightGrams': json['weight_grams'],
        'hasError': json['has_error'],
        'thumbnailUrl': json['thumbnail_url'],
        'triageResult': TriageResultFromJSON(json['triage_result']),
        'annotation': CaptureAnnotationFromJSON(json['annotation']),
        'source': CaptureSourceFromJSON(json['source']),
        'linkedCaptureId': json['linked_capture_id'],
        'manualOrigin': json['manual_origin'] === undefined ? undefined : json['manual_origin'] === null ? null : ManualCaptureOriginFromJSON(json['manual_origin']),
        'phoneLoggedAt': json['phone_logged_at'] === undefined ? undefined : json['phone_logged_at'] === null ? null : (parseDateTime(json['phone_logged_at'])),
        'phoneGps': json['phone_gps'] === undefined ? undefined : json['phone_gps'] === null ? null : PhoneGpsFromJSON(json['phone_gps']),
        'speciesResult': json['species_result'] === undefined ? undefined : json['species_result'] === null ? null : SpeciesResultSchemaFromJSON(json['species_result']),
        'serverLengthMillimeters': json['server_length_millimeters'] === undefined ? undefined : json['server_length_millimeters'] === null ? null : json['server_length_millimeters'],
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(CaptureLabelSchemaFromJSON)),
        'runStartedTimestamp': json['run_started_timestamp'],
        'lengthMethod': json['length_method'],
        'lengthConfidence': json['length_confidence'],
        'gpsLastValidFix': GpsValidFixFromJSON(json['gps_last_valid_fix']),
        'gpsLastValidFixTime': json['gps_last_valid_fix_time'],
        'imageError': json['image_error'],
        'lengthError': json['length_error'],
        'imu': ImuSampleFromJSON(json['imu']),
        'weightDebug': WeightDebugFromJSON(json['weight_debug']),
        'frames': (json['frames'] == null ? null : (json['frames'] as Array<any>).map(FrameMetadataFromJSON)),
        'chosenFrameIndex': json['chosen_frame_index'],
        'images': ((json['images'] as Array<any>).map(ImageSchemaFromJSON)),
        'media': ((json['media'] as Array<any>).map(MediaSchemaFromJSON)),
        'linkedCapture': CaptureSummaryFromJSON(json['linked_capture']),
        'serverLength': json['server_length'] === undefined ? undefined : json['server_length'] === null ? null : ServerLengthSchemaFromJSON(json['server_length']),
        'resultJsonPresignedUrl': json['result_json_presigned_url'] === undefined ? undefined : json['result_json_presigned_url'] === null ? null : json['result_json_presigned_url'],
        'appliedShiftSeconds': json['applied_shift_seconds'] == null ? undefined : json['applied_shift_seconds'],
    };
}

export function CaptureDetailToJSON(json: any): CaptureDetail {
    return CaptureDetailToJSONTyped(json, false);
}

export function CaptureDetailToJSONTyped(value?: CaptureDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_id': value['captureId'],
        'catch_id': value['catchId'],
        'run_id': value['runId'],
        'device_id': value['deviceId'],
        'hostname': value['hostname'],
        'display_code': value['displayCode'],
        'trigger_source': TriggerSourceToJSON(value['triggerSource']),
        'capture_start_timestamp': value['captureStartTimestamp'],
        'capture_end_timestamp': value['captureEndTimestamp'],
        'capture_duration_seconds': value['captureDurationSeconds'],
        'length_millimeters': value['lengthMillimeters'],
        'weight_grams': value['weightGrams'],
        'has_error': value['hasError'],
        'thumbnail_url': value['thumbnailUrl'],
        'triage_result': TriageResultToJSON(value['triageResult']),
        'annotation': CaptureAnnotationToJSON(value['annotation']),
        'source': CaptureSourceToJSON(value['source']),
        'linked_capture_id': value['linkedCaptureId'],
        'manual_origin': ManualCaptureOriginToJSON(value['manualOrigin']),
        'phone_logged_at': value['phoneLoggedAt'] == null ? value['phoneLoggedAt'] : serializeDateTime(value['phoneLoggedAt']),
        'phone_gps': PhoneGpsToJSON(value['phoneGps']),
        'species_result': SpeciesResultSchemaToJSON(value['speciesResult']),
        'server_length_millimeters': value['serverLengthMillimeters'],
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(CaptureLabelSchemaToJSON)),
        'run_started_timestamp': value['runStartedTimestamp'],
        'length_method': value['lengthMethod'],
        'length_confidence': value['lengthConfidence'],
        'gps_last_valid_fix': GpsValidFixToJSON(value['gpsLastValidFix']),
        'gps_last_valid_fix_time': value['gpsLastValidFixTime'],
        'image_error': value['imageError'],
        'length_error': value['lengthError'],
        'imu': ImuSampleToJSON(value['imu']),
        'weight_debug': WeightDebugToJSON(value['weightDebug']),
        'frames': (value['frames'] == null ? null : (value['frames'] as Array<any>).map(FrameMetadataToJSON)),
        'chosen_frame_index': value['chosenFrameIndex'],
        'images': ((value['images'] as Array<any>).map(ImageSchemaToJSON)),
        'media': ((value['media'] as Array<any>).map(MediaSchemaToJSON)),
        'linked_capture': CaptureSummaryToJSON(value['linkedCapture']),
        'server_length': ServerLengthSchemaToJSON(value['serverLength']),
        'result_json_presigned_url': value['resultJsonPresignedUrl'],
        'applied_shift_seconds': value['appliedShiftSeconds'],
    };
}

